// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"cb498362","725":"b25f890a","855":"fe670555","976":"88c4c62f"}[chunkId] + ".chunk.js";
};